import classNames from 'classnames';
import PropTypes from 'prop-types';

const ErrorMessage = ({ errors, className, id }) => (
  <div
    className={classNames('alert-box alert-box--error flexbox', className)}
    data-testid="error-message"
    id={id}
  >
    <div className="flexbox__item v-middle">
      <i className="icon-warning icon-size--200" />
    </div>
    <div className="flexbox__item v-middle soft--left one-whole text--left">
      {errors.map((error) => (
        <div key={error}>{error}</div>
      ))}
    </div>
  </div>
);

ErrorMessage.propTypes = {
  errors: PropTypes.array.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default ErrorMessage;
